import {useCallback} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Form, Grid, Segment} from 'semantic-ui-react';
import SellersReservePriceTip from './SellersReservePriceTip';
import ReservePriceFieldTip from './ReservePriceFieldTip';
import DollarInputFormField from './DollarInputFormField';
import NumberValidator from '../lib/NumberValidator';
import {updateSellersReservePrice} from '../ducks/sellersReservePrice';

export default function SellersReservePrice() {
  const dispatch = useDispatch();
  const reservePrice = useSelector((state) => state.sellersReservePrice.reservePrice);

  const onReservePriceChange = useCallback((e, target) => {
    if (NumberValidator.isValidInteger(target.value, 8)) {
      // The field is optional, so an emptied input is stored as null rather than NaN.
      const value = '' === target.value ? null : parseInt(target.value, 10);
      dispatch(updateSellersReservePrice({reservePrice: value}, true));
    }
  }, [dispatch]);

  return (
    <Segment basic className="sellers-reserve-price-segment">
      <Grid centered>
        <Grid.Row style={{paddingBottom: '0'}}>
          <Grid.Column width={16} style={{padding: '0'}}>
            <Form className="sellers-reserve-price">
              <h3>
                Seller's Reserve Price <SellersReservePriceTip/>
              </h3>
              <Form.Group>
                <Form.Field width={5} className="reserve-price-label" style={{paddingTop: '0.5em'}}>
                  <label>Reserve Price <ReservePriceFieldTip/></label>
                </Form.Field>
                <DollarInputFormField
                  className="reserve-price"
                  inputValue={reservePrice}
                  placeholder="amount"
                  name="reservePrice"
                  onChange={onReservePriceChange}/>
              </Form.Group>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
}
